import {useContext, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Button, {atomButtonDesigns, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close'
import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import CardDealerLocationsModalContent from './card-dealer-locations-modal-content.js'

const BASE_CLASS = 'mt-CardDealerLocations'
const BASE_CLASS_CONTENT = `${BASE_CLASS}-content`

const DATA_TEST_DESCRIPTION = 'card-dealer-locations-description'
const MAX_PROVINCES_INLINE = 2

export default function CardDealerLocations({
  isCanarias = false,
  locations,
  showFlexibleDeliveryTag = false,
  pageName
}) {
  const {provinceIds} = locations
  const {i18n} = useContext(Context)

  const [isModalOpen, setModalState] = useState(false)

  const services = [
    {
      type: 'cash',
      title: i18n.t('DEALER_LOCATIONS.MORE_CAR_DEALS_NAME'),
      description: i18n.t('DEALER_LOCATIONS.MORE_CAR_DEALS_DESCRIPTION')
    },
    {
      type: 'earth-home',
      title: i18n.t('DEALER_LOCATIONS.WITHOUT_MOVING_NAME'),
      description: i18n.t('DEALER_LOCATIONS.WITHOUT_MOVING_DESCRIPTION')
    },
    {
      type: 'bag-heart',
      title: i18n.t('DEALER_LOCATIONS.PURCHASE_OPTIONS_NAME'),
      description: i18n.t('DEALER_LOCATIONS.PURCHASE_OPTIONS_DESCRIPTION')
    },
    {
      type: 'deal',
      title: i18n.t('DEALER_LOCATIONS.AGREEMENT_WITH_SELLER_NAME'),
      description: i18n.t('DEALER_LOCATIONS.AGREEMENT_WITH_SELLER_DESCRIPTION')
    },
    {
      type: 'car-extended-warranty',
      title: i18n.t('DEALER_LOCATIONS.WARRANTY_OUR_PROFESSIONALS_NAME'),
      description: i18n.t('DEALER_LOCATIONS.WARRANTY_OUR_PROFESSIONALS_DESCRIPTION')
    }
  ]

  const handleCloseModal = () => setModalState(false)

  const CardContent = () => (
    <div className={contentClass}>
      <div className={`${BASE_CLASS}-text`}>
        <div className={`${BASE_CLASS}-textInfo`}>
          <TitleBasic
            as={titleBasicTags.h2}
            color={titleBasicColors.black}
            size={titleBasicSizes.xs}
            title={i18n.t(isCanarias ? 'COMMON.FLEXIBLE_DELIVERY_CANARIAS' : 'COMMON.FLEXIBLE_DELIVERY')}
          />
          <div className={`${BASE_CLASS}-textDescription`} data-testid={DATA_TEST_DESCRIPTION}>
            {i18n.t(
              isCanarias
                ? 'DEALER_SERVICE.DEALER_SERVICES_LOCATION_CANARIAS'
                : 'DEALER_SERVICE.DEALER_SERVICES_LOCATION'
            )}
          </div>
        </div>
      </div>
      <div className={`${BASE_CLASS}-textLink`}>
        <Button
          link
          onClick={() => {
            setModalState(true)
          }}
          design={atomButtonDesigns.LINK}
          size={atomButtonSizes.SMALL}
          role="button"
        >
          {i18n.t('COMMON.KNOW_MORE')}
        </Button>
      </div>
    </div>
  )

  const contentClass = cx(BASE_CLASS_CONTENT, {
    [`${BASE_CLASS_CONTENT}Line`]: provinceIds.length <= MAX_PROVINCES_INLINE
  })

  const containerClass = cx(`${BASE_CLASS} ${BASE_CLASS}-container`, {
    [`${BASE_CLASS}-containerBox`]: showFlexibleDeliveryTag
  })

  return (
    <div className={containerClass}>
      <CardContent />

      <MoleculeModal
        isOpen={isModalOpen}
        closeOnOutsideClick
        closeOnEscKeyDown
        iconClose={<IconClose color="black" render="lazy" size="medium" />}
        onClose={handleCloseModal}
      >
        <CardDealerLocationsModalContent services={services} pageName={pageName} />
      </MoleculeModal>
    </div>
  )
}

CardDealerLocations.displayName = 'CardDealerLocations'
CardDealerLocations.propTypes = {
  isCanarias: PropTypes.bool,
  locations: PropTypes.shape({
    mainProvinceId: PropTypes.number,
    provinceId: PropTypes.number,
    provinceIds: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number))
  }),
  showFlexibleDeliveryTag: PropTypes.bool,
  pageName: PropTypes.string
}
